<template>
    <div class="container">
        <div class="klarna_payment_modal_wrap mx-auto">
            <h1 class="klarna_payment_modal_title text-center font-weight-bold">
                Klarna Payment
                <button :disabled="isLoading" @click="abort" class="klarna_close_modal btn btn-link text-reset">
                    <svg height="20" width="20">
                        <path d="M11.1,10 L18.8,2.3 C19.1,2 19.1,1.5 18.8,1.2 C18.5,0.9 18,0.9 17.7,1.2 L10,8.9 L2.3,1.2 C2,0.9 1.5,0.9 1.2,1.2 C0.9,1.5 0.9,2 1.2,2.3 L8.9,10 L1.2,17.7 C0.9,18 0.9,18.5 1.2,18.8 C1.4,18.9 1.6,19 1.7,19 C1.9,19 2.1,18.9 2.3,18.8 L10,11.1 L17.7,18.8 C17.9,18.9 18.1,19 18.2,19 C18.4,19 18.6,18.9 18.8,18.8 C19.1,18.5 19.1,18 18.8,17.7 L11.1,10 Z"
                              fill="rgba(13, 13, 13, 1)"></path>
                    </svg>
                </button>
            </h1>

            <div class="klarna_payment_wrapper mb-5">
                <div id="klarna_payment_container" class="klarna_payment_container d-block mx-auto"></div>
            </div>

            <p v-if="showError && !isLoading"  class="alert alert-danger mx-auto text-center mb-4">Something went wrong. Please try again.</p>

            <div class="row mb-5 klarna_payment_btn_container">
                <div class="col-xs-6">
                    <button :disabled="isLoading" class="btn btn-danger btn-block py-3" @click="abort">{{ labelAbort }}</button>
                </div>
                <div class="col-xs-6">
                    <button :disabled="isLoading" class="btn btn-primary btn-block py-3" @click="proceed">{{ labelProceed }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'clientToken',
            'paymentId',
            'labelAbort',
            'labelProceed',
            'checkout'
        ],
        mounted() {
            Klarna.Payments.init({
                client_token: this.clientToken
            });

            Klarna.Payments.load({
                container: '#klarna_payment_container',
                payment_method_category: this.paymentId
            }, function (res) {
            });
        },
        computed: {},
        data() {
            return {
                isLoading: false,
                showError: false
            }
        },
        methods: {
            abort() {
                this.isLoading = true;
                window.location.reload(true);
            },
            proceed() {
                let _this = this;
                this.isLoading = true;

                let checkoutData = this.checkout;
                if (typeof this.checkout === 'string') {
                    checkoutData = JSON.parse(this.checkout);
                }
                Klarna.Payments.authorize(
                    {
                        payment_method_category: this.paymentId
                    },
                    checkoutData,
                    function (res) {
                        if (res.approved === true && res.authorization_token && res.authorization_token !== '') {
                            window.location.href = '/checkout/klarna/place-order/' + res.authorization_token;
                        } else {
                            _this.isLoading = false;
                            _this.showError = true;
                        }
                    }
                );
            }
        }
    }
</script>

<style scoped>

    .klarna_payment_modal_wrap {
        max-width: 600px;
    }

    .klarna_payment_modal_title {
        margin:20px 20px 50px;
    }

    .klarna_close_modal {
        position: absolute;
        right: 15px;
        top: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components/KlarnaPayment.vue